import { useEffect, useState } from 'react';

export const MOBILE_GAME_QUERY = '(max-width: 767px), (max-width: 1024px) and (max-height: 500px)';

/** Keep the rendered game composition in step with the mobile CSS breakpoint. */
export function useMobileGameLayout() {
  const [mobile, setMobile] = useState(() => window.matchMedia?.(MOBILE_GAME_QUERY).matches ?? false);
  useEffect(() => {
    const query = window.matchMedia?.(MOBILE_GAME_QUERY);
    if (!query) return;
    const update = () => setMobile(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return mobile;
}
